import React from "react";
import Router from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Context,Request } from "@xt/xtbase";
const {XtContext} = Context;
const {setHeader} = Request;
import stylesLess from "./index.module.less";
import { getAbsoluteUrl, getOrigin } from "utils/method";
import { isRtlLocale } from "@/utils/rtl";
import cookie from "utils/cookie";
import XtSvg from "components/Xt/Svg";
import LocalesMap from "locales/map";

import imgLogo_dark from "assets/images/logo-dark.svg";
import imgLogo_light from "assets/images/logo-light.svg";

export default observer(function Nav() {
  const router = Router.useRouter();
  const { isDark } = store.app;
  const [appState,appDispatch] = React.useContext(XtContext);

  const imgLogo = isDark ? imgLogo_dark : imgLogo_light;
  const domain = getOrigin("www");

  const handleThemeToggle = () => {
    // cookie.setDomain("theme", appState.isDark ? "light" : "dark");
    const cls = isDark ? "light" : "dark";
    cookie.set("theme", cls);
    store.app.updateState({theme: cls});
    appDispatch({
      payload: {
        theme: cls
      },
    });
    document.body.setAttribute("data-theme", cls);
  };
  const handleLangChange = (obj) => {
    cookie.set("lang", obj.key);
    cookie.set("langManual", "1");
    setHeader({lang:obj.key});
    appDispatch({
      payload: {
        lang: obj.name,
      },
    });
    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: router.asPath,
        locale: obj.name,
        basePath: "",
      }));
    router.push(router.asPath, router.asPath, { locale: obj.name });
  };

  const rtl = isRtlLocale(router.locale);

  return (
    <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}${rtl ? ` ${stylesLess.rtlNav}` : ""}`}>
      <a href={domain + "/" + router.locale}>
        <img className={`${stylesLess.logo}`} src={'/logo2.png'} alt="logo" />
      </a>

      <div className={"iRight"}>
        {/* <button className="btntxt ico" onClick={handleThemeToggle}>
          <XtSvg icon={isDark ? "theme-light" : "theme-dark"} />
        </button> */}

        <div className={"iDrop"}>
          <button className="btntxt ico">
            <XtSvg icon={"language"} />
          </button>
          <div>
            {LocalesMap.map((item) => {
              return (
                <button
                  key={item.key}
                  className={`iDropLi btntxt ${
                    item.name === router.locale ? "atv" : ""
                  }`}
                  onClick={() => handleLangChange(item)}
                >
                  {item.lab}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
});
